import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, ViewChild, AfterViewInit } from '@angular/core';
import { Observable, Subject, forkJoin } from 'rxjs';
import { sweetAlert, sweetAlertWithInput } from 'src/app/utils/swal';
import { takeUntil } from 'rxjs/operators';
import { Events } from 'src/app/utils/event-utils';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { ActivatedRoute } from '@angular/router';
import { DriversService } from '../../component/drivers/drivers-service/drivers-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../../component/assigned-trips/assigntrips-service/assigntrips-service';
import { animate, style, transition, trigger } from "@angular/animations";
import { getAvailabilityBadges, getBorderColor, getBrokersList, getDistanceFromLatLon } from 'src/app/utils/utils.common';
import { AgmMap } from '@agm/core';
import * as moment from 'moment-timezone';
import { CorporateService } from '../../component/corporate-user/corporate-service/corporate-service';
import { LevelOfServiceService } from '../../component/level-of-service/service/level-of-service.service';
import { ServiceAreasService } from '../../component/service-areas/service-areas-service/service-areas.service';
import { FarmoutService } from 'src/app/service/farmout-service/farmout.service';
import { HolidayService } from 'src/app/component/extras/holidays/service/holiday.service';
import { AssistService } from 'src/app/service/assist-service/assist.service';
declare var $;
@Component({
  selector: 'app-trip-assign-modal',
  templateUrl: './trip-assign-modal.component.html',
  styleUrls: ['./trip-assign-modal.component.css'],
  animations: [
    trigger("openCloseAssignSlideOut", [
      transition(":enter", [
        style({ opacity: 0, transform: "translateX(100%)" }),
        animate(
          "750ms ease-in-out",
          style({ opacity: 1, transform: "translateX(0)" })
        )
      ]),
      transition(":leave", [
        style({ opacity: 1, transform: "translateX(0)" }),
        animate(
          "750ms ease-in-out",
          style({ opacity: 0, transform: "translateX(-100%%)" })
        )
      ])
    ])
  ]
})
export class TripAssignModalComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @ViewChild("AgmMap", { static: true }) agmElement: AgmMap;

  @Input('assignModalObj') trip: any;

  @Input() dateRange: any;
  @Input() componentType: string;
  @Input() secondaryCompType: string;
  @Output() tripAssigned = new EventEmitter<any>();
  @Output() onCloseModal = new EventEmitter<any>();
  agmMap;
  user;
  searchDriver;
  selectedDriver = null;
  googleSelectedDriver = null;
  nearbyDrivers = [];

  manifestList = [];
  isSubmitted = false;
  isAttendee = "";
  isLivePrediction = true;

  requestType = null;
  multiAssignTripNote = null;
  cancelTripModalObj;
  origin = { lat: 0.00000, lng: 0.00000 };
  driverLoc = { lat: 0.00000, lng: 0.00000 };
  destination = { lat: 0.00000, lng: 0.00000 };
  preCorporate;
  preLevelOfServices = {};
  preSpaceTypes: any = {};
  preServiceAreas = {};
  isInfo = false;
  isAllowRoute = false;
  selectedMethod = true;

  runId;
  selectedFarmoutVehicle;
  farmoutVehicles;

  isFarmoutIntegration = false;
  allowFarmoutFareEstimation = false;
  isLoadingDrivers = false;
  cooperateHolidays;
  assistList;
  selectedAssist = [];
  isScheduleType = false;
  spaceTypes;
  filteredDrivers;
  selectedSpaceTypeId = '';
  superDrivers = [];
  isCapacity = true;
  isShowCapacityToggle = false;
  todayDate = [];
  timeZone;

  overTimeReason = '';
  userRole;
  isByPassed = false;
  farmoutNotes = '';
  preferredDriver:any = {};

  constructor(
    private assistService : AssistService,
    private holidayService: HolidayService,
    private serviceArea: ServiceAreasService,
    private levelOfServiceService: LevelOfServiceService,
    private corporateService: CorporateService,
    private driverService: DriversService,
    private assignTripService: AssigTripsService,
    private socketService: SocketService,
    private sharedDataService: SharedDataService,
    private farmoutService: FarmoutService,
    private  assigTripsService:AssigTripsService
  ) { }

  ngOnInit() {
    this.getUser();

    if (this.trip && !Array.isArray(this.trip)) {
      this.origin = {
        lat: this.trip.jobOriginLatitude,
        lng: this.trip.jobOriginLongitude
      };
      this.destination = {
        lat: this.trip.jobDestinationLatitude,
        lng: this.trip.jobDestinationLongitude
      };

      this.isByPassed = this.trip.status === "inprogress"
    }

    if (this.trip && this.trip.preferredDriver) {
      this.getDriverData();
    }

    this.listenSocket();
    this.makeCompulsoryCalls();
  }


   getDriverData() {
     this.driverService
       .getDriversByID(this.trip.preferredDriver)
       .pipe(takeUntil(componentDestroyed(this)))
       .subscribe(data => {
         if (data) {
           this.preferredDriver = data;
         }
       });
   }

  makeCompulsoryCalls() {
    const requests = [
      this.getLevelOfService(),
      this.getSpaceTypes(),
      this.getServiceAreas()
    ];

    if (this.componentType !== 'Multiple Assign') {
      requests.push(this.getCorporateUserById());
    }

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      async ([res1, res2, res3, res4]) => {
        if (res1) {
          this.preLevelOfServices = await res1.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (res2) {
          this.spaceTypes = res2;
          this.preSpaceTypes = await res2.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (res3) {
          this.preServiceAreas = await res3.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (res4) {
          if (this.componentType !== 'Multiple Assign') {
            this.preCorporate = res4;
          }
        }
        this.getNearbyDriver();
      },
      error => {
        sweetAlert('Error', error, 'warning', 'OK');
      }
    );
    if(this.trip.cooperate){
      this.getHolidaysByCooperate();
    }
  }

  getHolidaysByCooperate() {
    let param = {
      cooperate: this.trip.cooperate
    }
    this.holidayService.getHolidaysByCooperate(param).subscribe((data) => {
      if (data) {
        this.cooperateHolidays = data;
        //  if(this.cooperateHolidays && this.cooperateHolidays.length){
        //   this.checkHolidayForTrip(this.trip, this.cooperateHolidays);
        //  }
      }
    })
  }

  checkHolidayForTrip(trip, holidays) {
    const tripScheduleTime = moment(trip.scheduleTime).tz(this.user.timeZone);
    const holidayDays = [];

    for (let holiday of holidays) {
      const holidayStart = moment(holiday.startTime).tz(this.user.timeZone).startOf('day');
      const holidayEnd = moment(holiday.endTime).tz(this.user.timeZone).endOf('day');
      if (tripScheduleTime.isBetween(holidayStart, holidayEnd)) {
        holidayDays.push(holiday.name);
      }
    }

    return holidayDays;
  };

  ngOnChanges(changes): void {
    if (changes.trip && changes.trip.currentValue) {
      if (changes.trip.currentValue.attendees)
        this.isAttendee = changes.trip.currentValue.attendees;
      if (changes.trip.currentValue.driver)
        this.selectedDriver = changes.trip.currentValue.driver;
    }
  }

  ngAfterViewInit() {
    // this.agmElement.mapReady
    //   .pipe(takeUntil(componentDestroyed(this)))
    //   .subscribe((map) => {
    //     this.agmMap = map;
    //    let trafficLayer = new google.maps.TrafficLayer();
    //     trafficLayer.setMap(this.agmMap);
    //   });
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
          if(this.user.hasOwnProperty('isFarmout')) {
            this.isFarmoutIntegration = this.user.isFarmout
          }
          this.todayDate = [
            moment().tz(this.timeZone).startOf('day').toISOString(),
            moment().tz(this.timeZone).endOf('day').toISOString()
          ];
          this.getAssisData();
          this.getDrivers();
        }
      });
  }

  getNearbyDriver() {
    if (this.isLoadingDrivers) return;
    this.isLoadingDrivers = true;
    let data: any = {}
    if (this.componentType !== 'Multiple Assign') {
      if (this.preSpaceTypes && this.trip.spaceType && this.preSpaceTypes[this.trip.spaceType]) {
        let violation = undefined;
        if(this.user && this.user.company && this.user.company.hasOwnProperty("assignByViolation")) {
          violation = this.user.company.assignByViolation;
        } else if(this.user && this.user.hasOwnProperty("assignByViolation")) {
          violation = this.user.assignByViolation;
        }
        data = {
          jobOriginLatitude: this.trip.jobOriginLatitude,
          jobOriginLongitude: this.trip.jobOriginLongitude,
          jobOriginAddress: this.trip.jobOriginAddress,

          fundingSource: this.trip.cooperate,
          spaceType: this.trip.spaceType,
          scheduleTime: this.trip.scheduleTime,
          isNearBy: true,
          loadTime: this.preSpaceTypes[this.trip.spaceType].loadTime || "0",
          unloadTime: this.preSpaceTypes[this.trip.spaceType].unloadTime || "0",
          milage: this.trip.milage,
          jobDestinationLatitude: this.trip.jobDestinationLatitude,
          jobDestinationLongitude: this.trip.jobDestinationLongitude,
          jobDestinationAddress: this.trip.jobDestinationAddress,
          assignByViolation: violation ? true : false,
          appointmentTime: this.trip.appointmentTime,
        };

        if (this.trip.serviceArea) {
          data.serviceArea = this.trip.serviceArea
        }

        if (this.preCorporate && this.preCorporate.companyType) {
          data.companyType =this.preCorporate.companyType;
        }
      } else {
        sweetAlert('Error', "Space Type issue with trip/vehicle.", 'error', 'OK');
        return;
      }
    }


    this.driverService
      .getNearbyDriversForAssign(data)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.drivers) {
          this.nearbyDrivers = data.drivers;
          this.nearbyDrivers.sort((a, b) => {
            const milesA = (typeof a.miles === 'number' && !isNaN(a.miles)) ? a.miles : Infinity;
            const milesB = (typeof b.miles === 'number' && !isNaN(b.miles)) ? b.miles : Infinity;
            return milesA - milesB;
          });


          // Temporarily Stop
          // filter drivers based on spacetype of trip
          // if (this.trip && this.trip.spaceType) {
          //   this.selectedSpaceTypeId = this.trip.spaceType;
          //   this.onChangeSpaceType();
          // }

          // this.nearbyDrivers.sort( function( a, b ) { return a.priority - b.priority; } )
          this.filterCapacityBaseTrips();
        }
        this.isLoadingDrivers = false;
      }, err => {
        this.isLoadingDrivers = false;
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  associatedDriver(driver) {
    for (const superDriver of this.superDrivers) {
      if (superDriver.associateDrivers.includes(driver._id)) return superDriver;
    }
    return null;
  }

  onSelectDriver(driver) {
    this.selectedDriver = driver;
    if (this.componentType !== 'Multiple Assign')
      this.driverLoc = {
        lat: driver.coords[1],
        lng: driver.coords[0]
      };


    if (driver.assigns && driver.assigns.length) {
      this.manifestList = driver.assigns;
    } else {
      this.getManifestTrips();
    }
  }

validateHolidays() {
    if (this.cooperateHolidays && this.cooperateHolidays.length) {
      const resdays = this.checkHolidayForTrip(this.trip, this.cooperateHolidays);
      if (resdays && resdays.length) {
        sweetAlert('Alert', `Member may be unavailable due to ${resdays.toString()}. Please confirm before assigning the trip. `, 'warning', 'Yes, Assign', 'No')
          .then((result) => {
            if (result.value) {
              this.assignTrip();
            }
          });
      }else {
        this.assignTrip();
      }
    } else {
      this.assignTrip();
    }
  }

  assignAssistTrip() {
    this.requestType = 'Assign Attendee';
    let payload;

    if (this.componentType === 'Multiple Assign') {
      payload = {
        selectedTrips: this.trip,
        status: 'updateattendees',
        attendees: this.selectedAssist && this.selectedAssist.length ? this.selectedAssist : []
      };
      this.updateMultipleAssist(payload);
    } else {
       payload = {
        ...this.trip,
        attendees: this.selectedAssist && this.selectedAssist.length ? this.selectedAssist : null
      };
      this.assignSingleTrip(payload);
    }

  }

  async assignTrip() {
    this.isSubmitted = true;
    if (!this.selectedDriver) return;

    if (this.selectedDriver.hasCheckout) {
      sweetAlert('Warning', `${this.selectedDriver.displayName}'s shift has already ended.`, 'warning', 'OK');
      return;
    }

    if (this.selectedDriver.hasOvtimeViolation) {
      sweetAlertWithInput(
        "Alert",
        `Felix Encarnacion has exceeded the allowed working hours. Are you sure you want to assign this trip?`,
        "warning",
        "Yes, Assign",
        "No",
        true,
       "Min. 10 characters."
      ).then((result: any) => {
        if (result.value) {
          this.overTimeReason = result.value.note;
          this.proceedwithAssignment();
        }
      });
    } else {
      this.proceedwithAssignment();
    }
  }

  async proceedwithAssignment() {

    const driver = await this.driverService
      .getDriversByID(this.selectedDriver._id).toPromise();

    if(!(driver && driver.fleet)) {
      sweetAlert('Error', `No vehicle associate with '${driver.displayName}'.`, 'warning', 'OK');
      return;
    }


    if (this.selectedDriver) {
      if (this.allowFarmoutFareEstimation) {
        if (this.selectedFarmoutVehicle) {
          if (this.isScheduleType) {
            sweetAlert('Alert', `Are you sure you want to schedule this trip for ${moment(this.trip.scheduleTime).tz(this.user.timeZone).format('MM/DD/YYYY HH:mm')}?`, 'warning', 'Yes', 'No')
              .then((result) => {
                if (result.value) {
                  this.createRequest();
                }
              });
          }
          else {
            sweetAlert('Alert', `Are you sure you want to assign this trip now ?`, 'warning', 'Yes', 'No')
              .then((result) => {
                if (result.value) {
                  this.createRequest();
                }
              });
          }
        }
      } else {
        if (this.componentType === 'Multiple Assign') {
          this.requestType = 'Multiple Assign';
          let data: any = {
            selectedTrips: this.trip,
            status: 'offered',
            priority: 0,
            assignThrough: 'panel',
            driver: this.selectedDriver,
            note: this.multiAssignTripNote
          };
          if (this.overTimeReason) data.overTimeReason = this.overTimeReason;
          this.assignMultipleTrips(data);
        } else {
          this.requestType = 'Assign';
          this.trip.driver = this.selectedDriver._id;
          this.trip.status = 'offered';
          this.trip.jobStatus = 'offered';
          this.trip.assignThrough = 'panel';
          this.trip.priority = 0;
          if (this.overTimeReason) this.trip.overTimeReason = this.overTimeReason;

          if (this.isByPassed) {
            this.trip.isByPassed = true
          }
          this.assignSingleTrip(this.trip);

        }
      }
    }
  }

  assignSingleTrip(payload) {

    this.assignTripService
      .assignTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (this.requestType === 'Un Assign') {
            this.tripAssigned.emit('Trip Un Assigned');
          } else if (this.requestType === 'Assign') {
            this.tripAssigned.emit('Trip Assigned');
          }else if (this.requestType === 'Assign Attendee') {
            this.tripAssigned.emit('Attendee Assigned');
          }
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  assignMultipleTrips(payload) {
    this.assignTripService
      .assignMultipleTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.tripAssigned.emit('All Trips Assigned');
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      })
  }

  updateMultipleAssist(payload) {
    this.assignTripService
      .assignMultipleTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.tripAssigned.emit('All Trips Assigned');
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      })
  }

  unAssignTrip() {
    // this.trip.status = 'unassigned';
    // this.trip.jobStatus = 'pending';
    // this.assignTripService
    //   .assignTrip(this.trip)
    //   .pipe(takeUntil(componentDestroyed(this)))
    //   .subscribe(data => {
    //     if (data) {
    //       this.tripAssigned.emit('Trip Un Assigned');

    //     }
    //   });
    let payload;
    if (this.componentType === 'Multiple Assign') {
      payload = {
        selectedTrips: this.trip,
        status: 'unassigned',
        priority : 0,
        assignThrough : 'panel'
      }
      this.updateMultipleTrips(payload);
    } else {
      this.trip.jobStatus = 'pending';
      this.trip.status = 'unassigned';
      this.trip.priority = 0;
      this.trip.assignThrough = 'panel';

      if (this.isByPassed) {
        this.trip.isByPassed = true
      }
      this.updateSingleTrip(this.trip);
    }
  }

  archiveTrip() {
    let payload;
    if (this.componentType === 'Multiple Assign') {
      payload = {
        selectedTrips: this.trip,
        status: 'archived'
      }
      this.updateMultipleTrips(payload);
    } else {
      this.trip.status = 'archived';
      this.updateSingleTrip(this.trip);
    }
    // sweetAlert('Alert','Are you sure you want to archive the trip?','warning','Yes','No')
    // .then((result) => {
    //   if(result.value) {
    //     this.trip.status = "archived";
    //     this.assignTripService
    //       .assignTrip(this.trip)
    //       .subscribe(data => {
    //       if (data) {
    //       }
    //   });
    //   }
    //   else if(result.dismiss){
    //     // close();
    //   }
    // });
  }

  updateJob(assign, assignKey) {
    let params = {
      assignId: assign._id
    }
    params[assignKey] = !assign[assignKey];
    this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
    this.tripAssigned.emit('Trip Assigned');
  }

  sendToMarketplace() {
    let payload;
    if (this.componentType === 'Multiple Assign') {
      payload = {
        selectedTrips: this.trip,
        status: 'marketplaced'
      }
      this.updateMultipleTrips(payload);

    } else {
      this.trip.jobStatus = 'marketplaced';
      this.trip.status = 'unassigned'
      this.updateSingleTrip(this.trip);

    }
  }

  setRequestType(requestType) {
    this.requestType = requestType;
  }

  getETA() {
    this.assignTripService
      .getETA(this.trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.trip.etaMessage = data.etaMessage;
        }
      });
  }

  getMiles(driverIndex, driver) {
    this.googleSelectedDriver = null;

    if (this.trip.jobOriginLatitude && this.trip.jobOriginLongitude && this.trip.jobDestinationLatitude && this.trip.jobDestinationLongitude) {
      const locationParams = {
        origin: this.trip.jobOriginLatitude + ' , ' + this.trip.jobOriginLongitude,
        destination: driver.coords[1] + ' , ' + driver.coords[0]
        // destination: vm.assign.jobDestinationLatitude + ' , ' + vm.assign.jobDestinationLongitude
      };
      locationParams['dbMiles'] = driver.miles || 0;
      locationParams['isLog'] = true;
      this.socketService.emit(Events.GET_DRIVER_MILES_FOR_ASSIGN_MODAL, locationParams);
      // Socket.emit(‘assignTripManualFormETA’, locationParams);
      this.googleSelectedDriver = driver;
    } else {
      sweetAlert('Error', 'Please Select Pickup and DropOff Address', 'warning', 'OK');
    }
  }

  listenSocket() {
    this.socketService.addListener(Events.UPDATE_ASSIGN_TRIP)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          // sweetAlert('Success', data.message, 'success', 'OK');
          if (data.assign) {
            this.trip.isReadyForPickup = data.assign.isReadyForPickup;
            this.trip.isVipTrip = data.assign.isVipTrip;
            this.trip.isConfirmedTrip = data.assign.isConfirmedTrip;
            this.trip.isVoiceMail = data.assign.isVoiceMail;
            this.trip.isMultiLoad = data.assign.isMultiLoad;
          }
        } else {
          sweetAlert('Error', data.message, 'warning', 'OK');
        }
      });

    this.socketService.addListener(Events.GET_DRIVER_MILES_FOR_ASSIGN_MODAL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (!this.googleSelectedDriver) return;
        const driverIndex = this.nearbyDrivers.findIndex(driver => driver._id === this.googleSelectedDriver._id);
        if (data.success) {
          this.nearbyDrivers[driverIndex].googleETA = data.message;
        } else {
          this.nearbyDrivers[driverIndex].googleETA = null;
        }
      });
  }

  cancelTrip() {
    this.cancelTripModalObj = this.trip;
  }

  closeModal() {
    this.onCloseModal.emit('close');
  }

  closeConfirmation() {
    this.requestType = '';
  }

  modalClose() {
    $('#assignModal .close').click();
  }

  closeCancelModal() {
    this.cancelTripModalObj = null;
    this.tripAssigned.emit('Trip Updated');
    // this.onCloseModal.emit('close');
  }

  // <p class="text-sm text-main-light" *ngIf = "requestType === 'archive'" class="modal-title" id="myLargeModalLabel"> Are you sure you want to archive ?</p>
  //                 <p class="text-sm text-main-light" *ngIf = "requestType === 'market place'" class="modal-title" id="myLargeModalLabel">Are you sure you want to send this trip to marketplace?</p>
  //               <p class="text-sm text-main-light" *ngIf = "requestType === 'Un Assign'" class="modal-title" id="myLargeModalLabel">Are you sure you want to send this trip to unassigned?</p>
  _updateJob(trip) {
    let payload;
    if (this.componentType === 'Multiple Assign') {
      if (this.requestType === 'archive') {
        payload = {
          selectedTrips: trip,
          status: 'archived'
        }
      } else if (this.requestType === 'market place') {
        payload = {
          selectedTrips: trip,
          status: 'marketplaced'
        }
      } else if (this.requestType === 'Un Assign') {
        payload = {
          selectedTrips: trip,
          status: 'unassigned'
        }
      }
      this.updateMultipleTrips(payload);
    } else {
      if (this.requestType === 'archive') {
        this.trip.status = 'archived';
      } else if (this.requestType === 'market place') {
        this.trip.jobStatus = 'marketplaced';
      } else if (this.requestType === 'Un Assign') {
        this.trip.status = 'unassigned';
        this.trip.jobStatus = 'pending';
      }
      this.updateSingleTrip(trip);
    }
  }

  updateMultipleTrips(payload) {
    this.assignTripService
      .assignMultipleTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.tripAssigned.emit('Trip Assigned');
          // sweetAlert('Success', 'Trip Updated', 'success', 'OK');
        }
      });
  }

  updateSingleTrip(payload) {
    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.tripAssigned.emit('Trip Assigned');
          // sweetAlert('Success', 'Trip Updated', 'success', 'OK');
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  returnTrip() {
    this.cancelTrip();
  }

  brokerList(key?) {
    if (key) {
      return getBrokersList[key];
    }
    return getBrokersList;
  }


  getManifestTrips() {
    const payload = {
      scheduleTime: this.trip.scheduleTime,
      driverId: this.selectedDriver._id
    };
    this.manifestList = [];
    this.assignTripService
      .fetchManifestTrips(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(async data => {
        if (data && data.assigns) {
          this.manifestList = data.assigns;
          const findTrip = this.manifestList.find(item => item._id === this.trip._id)
          if (!findTrip) {
            this.manifestList.push({ ...this.trip, isPurposeTrip: true });
          } else {
            findTrip.isPurposeTrip = true;
          }
         await this.manifestList.sort(
            (a, b) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
          );

          await this.checkPossibility();
        }
      });
  }


  async checkPossibility() {
    let lastTrip;

    if (this.selectedDriver && this.selectedDriver.startingPointAddress) {
      lastTrip = this.selectedDriver;
      lastTrip.coords[1] = this.selectedDriver.startingPointAddress.latitude;
      lastTrip.coords[0] = this.selectedDriver.startingPointAddress.longitude;
      lastTrip.isGarage = true;
    }

    if (this.selectedDriver && this.selectedDriver.coords && this.selectedDriver.coords.length) {
      lastTrip = this.selectedDriver;
    }

    for (let myTrip of this.manifestList) {

      if (!lastTrip) {
        lastTrip = myTrip;
        continue
      }
      await this.setNextTripPickupTime(lastTrip, myTrip);
      lastTrip = myTrip;
    }

  }
  async setNextTripPickupTime(lastTrip, currentTrip) {
    let puDistanceAndTime;
    if (lastTrip.coords && lastTrip.coords.length) {
      puDistanceAndTime = await this.calculateDistance(
        lastTrip.coords[1], lastTrip.coords[0],
        currentTrip.jobOriginLatitude, currentTrip.jobOriginLongitude);
    } else {
      puDistanceAndTime = await this.calculateDistance(
        lastTrip.jobDestinationLatitude, lastTrip.jobDestinationLongitude,
        currentTrip.jobOriginLatitude, currentTrip.jobOriginLongitude);
    }


    let minutesToAdd = 0;
    if (puDistanceAndTime) {
      if (currentTrip.tripRequirement === 'WAV') {
        minutesToAdd += 5;
      } else if (currentTrip.tripRequirement === 'Stretcher') {
        minutesToAdd += 15;
      } else {
        minutesToAdd += 2;
      }

      let approxPUCurrentTrip;
      if (lastTrip.coords && lastTrip.coords.length) {
        approxPUCurrentTrip = moment().tz(this.user.timeZone).add(puDistanceAndTime.duration * minutesToAdd, 'minutes');

      } else {
        const lastAptTimePredic = lastTrip.approxDO ? lastTrip.approxDO : lastTrip.appointmentTime;
        approxPUCurrentTrip = moment(this.isLivePrediction ? lastAptTimePredic : lastTrip.appointmentTime).tz(this.user.timeZone).add(puDistanceAndTime.duration * minutesToAdd, 'minutes');
      }
      // to check late or on time
      let approxPUCurrentTripDiff = moment(currentTrip.scheduleTime).tz(this.user.timeZone).diff(approxPUCurrentTrip, 'minutes', true);


      // currentTrip.approxPU = {
      //   time: approxPUCurrentTrip.toISOString(),
      //   difference: approxPUCurrentTripDiff,
      //   pointsDistance: puDistanceAndTime
      // };
      currentTrip.approxPU = approxPUCurrentTrip.toISOString();
      // currentTrip.minutesToPickup = approxPUCurrentTripDiff;
      currentTrip.minutesToPickup = puDistanceAndTime.duration;
      currentTrip.puMiles = puDistanceAndTime.distance;

      const doDistanceAndTime = await this.calculateDistance(
        currentTrip.jobOriginLatitude, currentTrip.jobOriginLongitude,
        currentTrip.jobDestinationLatitude, currentTrip.jobDestinationLongitude);

      if (doDistanceAndTime) {

        let approxDOCurrentTrip = moment(currentTrip.approxPU).tz(this.user.timeZone).add(doDistanceAndTime.duration * minutesToAdd, 'minutes');
        // to check late or on time
        let approxDOCurrentTripDiff = moment(currentTrip.appointmentTime).tz(this.user.timeZone).diff(approxDOCurrentTrip, 'minutes', true);

        // currentTrip.approxDO = {
        //   time: approxDOCurrentTrip.toISOString(),
        //   difference: approxDOCurrentTripDiff,
        //   pointsDistance: doDistanceAndTime
        // };


      currentTrip.approxDO = approxDOCurrentTrip.toISOString();
      // currentTrip.minutesToPickup = approxDOCurrentTripDiff;
      currentTrip.minutesToPickup =  doDistanceAndTime.duration;
      currentTrip.puMiles = doDistanceAndTime.distance;

      }
    }
  }

   async calculateDistance(lat1, lon1, lat2, lon2) {
    let resutl;
    if (this.selectedMethod && this.selectedMethod === true) {
      resutl = await this.calculateDistanceWithGIS(lat1, lon1, lat2, lon2);
    } else {
      resutl = await new Promise((resolve) => { resolve(getDistanceFromLatLon(lat1, lon1, lat2, lon2))});
    }
    return resutl;
  }

  async calculateDistanceWithGIS(lat1, lon1, lat2, lon2) {
    const res: any = await this.assigTripsService.getRoutingDistance(lat1, lon1, lat2, lon2).toPromise();
    const segments: any = res.features[0].properties.segments;
    return {
      distance: (segments[0].distance / 1609),
      duration: (segments[0].duration / 60)
    };
  }

  onSelectedManifestTrip(item) {
    if (item.willProceed) return;
    item.isSelected = !item.isSelected;
  }

  async changePrediction() {
    this.isLivePrediction = !this.isLivePrediction;
    await this.checkPossibility();
  }

  getCorporateUserById() {
    return this.corporateService.getCorporateUserById(this.trip.cooperate)
      .pipe(takeUntil(componentDestroyed(this)))
  }

  getLevelOfService() {
    return this.levelOfServiceService.getLevelOfServices({ status: 'active' });
  }

  getSpaceTypes() {
    return this.levelOfServiceService.getSpaceTypes({ status: 'active' });
  }

  getServiceAreas() {
    return this.serviceArea.getServiceAreas({ status: 'active' });
  }

  openCloseInfo() {
    this.isInfo = !this.isInfo;
  }

validateFarmoutDrivers(){
    return this.driverService
      .getFarmoutDrivers();
  }

  onSelectFarmoutVehicle(vehicleFare) {
    this.selectedFarmoutVehicle = vehicleFare;
  }

  changeDriversView() {
    if (this.isLoadingDrivers) return;
    this.selectedDriver = null;
    this.farmoutVehicles = [];
    this.nearbyDrivers = [];
    this.filteredDrivers = null;
    this.selectedFarmoutVehicle = null;
    this.allowFarmoutFareEstimation = !this.allowFarmoutFareEstimation;
    this.manifestList = [];
    this.farmoutNotes = '';

    if (this.allowFarmoutFareEstimation) {
      this.fareEstimation();
      this.isScheduleType = false;
      const myUser = this.user && this.user.company ? this.user.company : this.user;
      if (myUser && myUser.callDispatcher) {
        this.farmoutNotes = `If passenger isn't visible, call '${myUser.callDispatcher}'. Passenger Contact: ${this.formatPhoneNumber(this.trip.priorityClient.contactNumber)} `
      }
    }

    this.getDriverList();
  }

  async fareEstimation() {
    if (this.isLoadingDrivers) return;
    this.isLoadingDrivers = true;
    const myUser = this.user && this.user.company ? this.user.company : this.user;
    const payload = {
      "pickup": {
        "latitude": this.trip.jobOriginLatitude,
        "longitude": this.trip.jobOriginLongitude
      },
      "dropoff": {
        "latitude": this.trip.jobDestinationLatitude,
        "longitude": this.trip.jobDestinationLongitude
      },
      "company": myUser._id
    }
    if (this.isScheduleType) {
      payload['scheduling'] = {
        pickup_time: moment(this.trip.scheduleTime).valueOf()
      }
    }

    this.farmoutService
      .fareEstimation(payload)
      .subscribe(data => {
        if (data) {
          // this.farmoutVehicles = data.product_estimates;
          this.farmoutVehicles = (data.uber && data.uber.product_estimates || [])
          .concat(data.lyft && data.lyft.cost_estimates || []);
        }
        this.isLoadingDrivers = false;
      }, err => {
        this.isLoadingDrivers = false;
        sweetAlert('Error', err,'warning', 'OK');
      });
  }

  getDrivers() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.superDrivers = data.filter(driver => driver.profileRole === 'superdriver' && Array.isArray(driver.associateDrivers));
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  async getDriverList() {
    if (this.allowFarmoutFareEstimation) {
      const uberDriver = await this.validateFarmoutDrivers().toPromise();
      if (uberDriver) {
        this.nearbyDrivers = uberDriver;
      }
    } else {
      this.getNearbyDriver();
    }
  }

  createRequest() {
    if (this.selectedFarmoutVehicle) {
      if (this.selectedFarmoutVehicle.product) {
        this.makeUberRequest();
      } else {
        this.makeLyftRequest();
      }
    }
  }

  async makeUberRequest() {

    const myUser = this.user && this.user.company ? this.user.company : this.user;

    if (!myUser.callDispatcher || !myUser.smsNotificationNumber) {
      sweetAlert('Alert', `SMS Notification or dispatcher number is missing in company profile.`, 'warning', 'OK')
      return
    }

    const memo = `T:${this.trip.tripId}|${this.trip._id}|D:${this.selectedDriver._id}`
    .slice(0, 255);

    const priorityClient = this.trip.priorityClient.displayName.split(' ');
    const payload = {
      "guest": {
        "first_name": priorityClient[0],
        "last_name": priorityClient.length > 1 ? priorityClient[1] : priorityClient[0],
        "phone_number":  this.formatPhoneNumber(myUser.callDispatcher),
        // "email": this.trip.priorityClient.email?this.trip.priorityClient.email:'',
      },
      "pickup": {
        "address": this.trip.jobOriginAddress,
        "latitude": this.trip.jobOriginLatitude,
        "longitude": this.trip.jobOriginLongitude
      },
      "dropoff": {
        "address": this.trip.jobDestinationAddress,
        "latitude": this.trip.jobDestinationLatitude,
        "longitude": this.trip.jobDestinationLongitude
      },
      "company": myUser._id,

      "product_id":  this.selectedFarmoutVehicle.product.product_id,
      "fare_id":  this.selectedFarmoutVehicle.estimate_info.fare_id,
      "expense_memo": memo,
      "sender_display_name":myUser.displayName,
      "note_for_driver": this.farmoutNotes,
      "call_enabled":false,
      "contacts_to_notify": [
        {
          "phone_number": this.formatPhoneNumber('(804) 718-0909'),
          "contact_event": ["TRIP_BEGAN"]
        }
      ],
      platform: 'farmout', // or uber
      panel: {
        ...this.trip,
        driver: this.selectedDriver._id,
        farmout: {
          "requestId": "",
          "productId": this.selectedFarmoutVehicle.product.product_id,
          "platform": 'uber',
          "message": '',
          "status": this.isScheduleType ? 'schedule' : 'processing',
          "createdAt": moment().tz(this.user.timeZone).toISOString()
        }
      }
    }

    if (this.isScheduleType) {
      payload['scheduling'] = {
        pickup_time: moment(this.trip.scheduleTime).valueOf()
      }
    }

    if (myUser.smsNotificationNumber) {
      for (const num of myUser.smsNotificationNumber.split(',')) {
        const cleaned = num.trim();

        // Skip empty, blank, or non-numeric values
        if (!cleaned || !/^\d+$/.test(cleaned)) continue;

        const phone = this.formatPhoneNumber(cleaned);

        payload['contacts_to_notify'].push({
          phone_number: phone,
          contact_event: ["TRIP_BEGAN"]
        });

        payload['contacts_to_notify'].push({
          phone_number: phone,
          contact_event: ["DRIVER_PICKUP_COMPLETED"]
        });
      }
    }

    this.farmoutService
      .rideRequest(payload)
      .subscribe(data => {
        if (data) {
          this.trip.farmout = {
            "requestId": data.request_id,
            "productId": data.product_id,
            "platform": 'uber',
            "message": '',
            "status": this.isScheduleType ? 'schedule' : 'processing',
            "createdAt": moment().tz(this.user.timeZone).toISOString()
          }
          this.trip.driver = this.selectedDriver._id;
          this.trip.status = 'offered';
          this.trip.jobStatus = 'offered';
          this.updateSingleTrip(this.trip);
          // sweetAlert('Success', 'Uber searching for a driver', 'success', 'OK')
        }
      }, err => {
        sweetAlert('Error', err,'warning', 'OK');
      });
  }

  async makeLyftRequest() {

    const myUser = this.user && this.user.company ? this.user.company : this.user;

    if (!myUser.callDispatcher || !myUser.smsNotificationNumber) {
      sweetAlert('Alert', `SMS Notification or dispatcher number is missing in company profile.`, 'warning', 'OK')
      return
    }

    const memo = `T:${this.trip.tripId}|${this.trip._id}|D:${this.selectedDriver._id}`
    .slice(0, 255);

    const priorityClient = this.trip.priorityClient.displayName.split(' ');

    const payload = {

      "ride_type": this.selectedFarmoutVehicle.ride_type,
      "origin": {
        "lat": this.trip.jobOriginLatitude,
        "lng": this.trip.jobOriginLongitude,
        "address": this.trip.jobOriginAddress
      },
      "destination": {
        "lat": this.trip.jobDestinationLatitude,
        "lng": this.trip.jobDestinationLongitude,
        "address": this.trip.jobDestinationAddress,
      },

      "passenger": {
        "first_name": priorityClient[0],
        "last_name": priorityClient.length > 1 ? priorityClient[1] : priorityClient[0],
        "phone_number": this.formatPhoneNumber(myUser.callDispatcher),
      },

      "driver_message": this.farmoutNotes,
      "cost_token": this.selectedFarmoutVehicle.cost_token,
      "external_note": memo,
      "ride_notif_recipient_phone_numbers": [
        // this.formatPhoneNumber('(804) 718-0909')
      ],
      "company": myUser._id,
      platform: 'farmout',

      panel: {
        ...this.trip,
        driver: this.selectedDriver._id,
        farmout: {
          "requestId": "",
          "productId": this.selectedFarmoutVehicle.ride_type,
          "message": '',
          "platform": 'lyft',
          "status": this.isScheduleType ? 'schedule' : 'processing',
          "createdAt": moment().tz(this.user.timeZone).toISOString()
        }
      }
    };


    if (this.isScheduleType) {
      payload['scheduled_pickup_range'] = {
        "timestamp_ms": moment(this.trip.scheduleTime).valueOf()
      }
    }

    if (myUser.smsNotificationNumber) {
      for (const num of myUser.smsNotificationNumber.split(',')) {
        const cleaned = num.trim();
        // Skip empty, blank, or non-numeric values
        if (!cleaned || !/^\d+$/.test(cleaned)) continue;
        const phone = this.formatPhoneNumber(cleaned);
        payload['ride_notif_recipient_phone_numbers'].push(phone);
      }
    }

    this.farmoutService
      .rideRequest(payload)
      .subscribe(data => {
        if (data) {
          this.trip.farmout = {
            "requestId": data.ride_id,
            "productId":this.selectedFarmoutVehicle.ride_type,
            "message": '',
            "platform": 'lyft',
            "status": this.isScheduleType ? 'schedule' : 'processing',
            "createdAt": moment().tz(this.user.timeZone).toISOString()
          }
          this.trip.driver = this.selectedDriver._id;
          this.trip.status = 'offered';
          this.trip.jobStatus = 'offered';
          this.updateSingleTrip(this.trip);
          // sweetAlert('Success', 'Uber searching for a driver', 'success', 'OK')
        }
      }, err => {
        sweetAlert('Error', err,'warning', 'OK');
      });
  }

  formatPhoneNumber = (input) => {
    // Remove all non-numeric characters
    let cleaned = input.replace(/\D/g, '');

    // Ensure it starts with the country code (e.g., "1" for US)
    if (cleaned.length === 10) {
      // Assume it's a US number, prepend the country code (+1)
      cleaned = '1' + cleaned;
    }

    // If the number is longer than expected, truncate it to 11 digits (for US)
    cleaned = cleaned.slice(0, 11);

    // Format the number in +1XXXXXXXXXX format
    return `+${cleaned}`;
  }

  getAssisData(){
    let queryParams = {
      scheduleTime: this.dateRange[0]
    }
    this.assistService.getAssistList(queryParams)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data => {
      if (data) {
        this.assistList = data;

        if(this.trip.attendees){
          this.selectedAssist = this.trip.attendees;
        }
      }
    });
  }
  onChangeAssist(){
  }

  changeSchedule(val) {
    this.isScheduleType = !val;
    this.fareEstimation();
    this.farmoutVehicles = [];
    this.selectedFarmoutVehicle = null;
  }
  getBorderColor(vehicle){
   return getBorderColor(vehicle)
  }
  getAvailabilityBadges(vehicle){
    return getAvailabilityBadges(vehicle)
  }

  onChangeSpaceType() {
    if (this.selectedSpaceTypeId) {
      this.filteredDrivers = this.nearbyDrivers.filter(driver => {
        return driver.fleet && driver.fleet.spaceType == this.selectedSpaceTypeId ? true : false;
      });
    } else {
      this.filteredDrivers = null;
    }
  }

  toggleCapacity() {
    this.isCapacity = !this.isCapacity;
    this.filterCapacityBaseTrips();
  }

  filterCapacityBaseTrips() {
    if (this.isCapacity) {
      this.filteredDrivers = this.nearbyDrivers.filter(driver => {
        return driver.fleet && driver.fleet.hasOwnProperty("isCapacity") && driver.fleet.isCapacity ? true : false;
      });
    } else {
      this.filteredDrivers = null;
    }
  }

ngOnDestroy(): void {
  }

  isSelectedVehicle(vehicle: any): boolean {
  if (!this.selectedFarmoutVehicle) return false;

  const selected = this.selectedFarmoutVehicle;

  const isSameProduct =
    selected.product &&
    vehicle.product &&
    selected.product.product_id === vehicle.product.product_id;

  const isSameRideType =
    selected.ride_type &&
    vehicle.ride_type &&
    selected.ride_type === vehicle.ride_type;

  return isSameProduct || isSameRideType;
}

}
